interface SelectOption {
  value: string
  label: string
  deleted?: boolean
}

interface PropertyConfig {
  options?: SelectOption[]
}

export const getDisplayValue = (
  rawValue: string | string[] | null | undefined,
  propertyConfig?: PropertyConfig,
): string => {
  if (rawValue == null || rawValue === '') return ''

  const options = propertyConfig?.options
  if (!options) {
    return Array.isArray(rawValue) ? rawValue.join(', ') : String(rawValue)
  }

  const getLabel = (val: string): string => {
    const option = options.find(opt => opt.value === val)
    return option?.label || val
  }

  if (Array.isArray(rawValue)) {
    return rawValue.map(getLabel).join(', ')
  }

  return getLabel(rawValue)
}
